export default __webpack_public_path__ + "static/media/calculator.2cd99bf5.png";